import { createContext, type Context } from 'react';

import { useRequiredContext } from '@/hooks';

export type CameraStreamFrameControlsContextType = {
  frameControlsVisible: boolean;
  /** Pause the idle hide countdown (e.g. while holding a radial pad sector). */
  setPauseHideTimer: (paused: boolean) => void;
};

export const CameraStreamFrameControlsContext: Context<
  CameraStreamFrameControlsContextType | undefined
> = createContext<CameraStreamFrameControlsContextType | undefined>(undefined);

export const useCameraStreamFrameControlsContext = (): CameraStreamFrameControlsContextType =>
  useRequiredContext({
    context: CameraStreamFrameControlsContext,
    hookName: 'useCameraStreamFrameControlsContext',
    providerName: 'CameraStreamFrameControlsProvider',
  });
